<nav class="app-breadcrumb" aria-label="breadcrumb">
  <ng-container *ngFor="let item of items; let last = last">
    <a *ngIf="item.route && !last" [routerLink]="item.route">{{ item.label }}</a>
    <span *ngIf="!item.route || last">{{ item.label }}</span>
    <i *ngIf="!last" class="fa-solid fa-chevron-right app-breadcrumb__separator"></i>
  </ng-container>
</nav>
